import { actionTypes, change as reduxChange } from 'redux-form';

export default store => next => action => {
	// let the action go to the reducers
	next(action);

	if (
		action.type !== actionTypes.CHANGE ||
		!action.meta ||
		action.meta.form !== 'bookingForm'||
		action.meta.field !== 'currency'
	) {
		return;
	}

	const state = store.getState();
	const formValues = state.form.bookingForm.values;

	const instruments = state.app.paymentGateway.instruments;
	if (instruments.hasOwnProperty(formValues.currency.id)) {
		if (instruments[formValues.currency.id].length === 1) {
			// pro nově nastavenou měnu máme v platební bráně dostupnou pouze jednu platební metodu - předvybereme ji
			store.dispatch(reduxChange('bookingForm', 'paymentMethod', instruments[formValues.currency.id][0].paymentInstrument));
		} else if (
			formValues.paymentMethod !== null
			&& instruments[formValues.currency.id].length > 1
			&& !instruments[formValues.currency.id].some(instrument => instrument.paymentInstrument === formValues.paymentMethod)
		) {
			// pro nově nastavenou měnu nemáme v platební bráně dostupnou zvolenou platební metodu
			store.dispatch(reduxChange('bookingForm', 'paymentMethod', null));
		}
	} else {
		// pro nově nastavenou měnu nemáme v platební bráně ani jednu platební metodu
		store.dispatch(reduxChange('bookingForm', 'paymentMethod', null));
	}
};


// WEBPACK FOOTER //
// ./src/store/currencyMiddleware.js